import { render } from "./setting-password.vue?vue&type=template&id=43d92cb3"
import script from "./setting-password.vue?vue&type=script&lang=js"
export * from "./setting-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__